import { epgCategoriesModel } from '$/epg/categories'
import { createEvent, createStore, sample } from 'effector'
import { not } from 'patronum'
import { T } from '~/shared/helpers'

interface ILoadParams {
  regionId?: number
}

// load categories list
export const load = createEvent<ILoadParams>()
export const $ready = createStore(false)

export const loadCategories = createEvent<ILoadParams>()

// prevent double categories loading
sample({
  clock: loadCategories,
  filter: not(epgCategoriesModel.loadPageFx.pending),
  target: epgCategoriesModel.loadPageFx,
})

// load categories list
sample({
  clock: load,
  filter: not($ready),
  target: loadCategories,
})

// set ready flag when categories are loaded
sample({
  clock: epgCategoriesModel.loadPageFx.done,
  fn: T,
  target: $ready,
})
